import React from 'react';
import { Form, Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class ChangeJob extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'roInput';
  mode = 'CJ';

  schema = {
    roInput: {
      errorText: 'Valid RO Required',
      label: 'Repair Order',
      required: true,
    },
    opInput: {
      errorText: 'Operation Number Required',
      label: 'Operation',
      required: true,
      regex: /^\d+$/,
    },
  };

  state = {
    roInput: {
      value: '',
      validationState: null,
    },
    opInput: {
      value: '',
      validationState: null,
    },
    opModes: null, // null | [{op: string, desc: string}, ...]
  };
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedROInput('roInput', opModes => {
              this.setState({ opInput: { value: '', validationState: null }, opModes });
            })}
            {this.validatedOperationInput('opInput', this.state.opModes)}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
